<template>
    <div id="tipAuth" aria-hidden="true"
         class="modal modal--rebrand fade over-all modal-with-custom-content modal-with-custom-content--dark-background"
         role="dialog" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-content-tabs">
                    <button @click.prevent="changeTab('guest')" :class="{'active': isGuestActive}">
                        {{ translate.home.guestGallery.guest }}
                    </button>
                    <button @click.prevent="changeTab('register')" :class="{'active': isRegisterActive}">
                        {{ translate.login.modalRegisterGallery.register }}
                    </button>
                    <button @click.prevent="changeTab('login')" :class="{'active': isLoginActive}">
                        {{ translate.login.login }}
                    </button>
                </div>

                <div class="modal-body" v-if="isGuestActive">
                    <div class="d-flex flex-column justify-content-center align-items-center">
                        <h5 class="tip-confirm-title mb-2">{{ translate.account.tips.sendTip }}</h5>
                        <p class="tip-confirm-description mb-0 text-center" v-html="confirmText"></p>

                        <button-with-loading-component
                            :loading="guestLoading"
                            :disabled="guestLoading"
                            @click.native.prevent="buyAsGuest()"
                            class="w-100 btn btn-rebrand-primary btn-rebrand-sm my-4"
                            :text="translate.home.guestGallery.purchaseWithoutAccount"
                        />

                        <span>{{ translate.home.guestGallery.or }}</span>

                        <span class="w-100 btn btn-rebrand-primary-outline btn-rebrand-sm mt-4 mb-1 cursor-pointer"
                              @click="changeTab('login')">
                            {{ translate.home.guestGallery.signInAndPurchase }}
                        </span>
                    </div>
                </div>

                <div class="modal-body" v-if="isRegisterActive">
                    <h5 class="heading mb-2" v-html="translate.home.registrationModal.registerForFree"></h5>
                    <p class="subheading mb-2">{{ translate.home.registrationModal.withFreeAccountYouGet }}</p>
                    <ul class="d-flex flex-column gap-2 mb-3">
                        <li v-for="(item, index) in translate.home.registrationModal.advantagesList" :key="index">
                            <icon-component :icon="checkmarkDouble()"/>
                            {{ item }}
                        </li>
                    </ul>
                    <punter-registration-component @successRedirect="onRegistrationSuccess"/>
                </div>

                <div class="modal-body" v-if="isLoginActive">
                    <h5 class="heading mb-2">{{ translate.login.login }}</h5>
                    <p class="subheading mb-3">{{ translate.login.signInToYourAccount }}</p>
                    <punter-login-component @successRedirect="onLoginSuccess"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import userMixin from "@/components/mixins/userMixin";
import PunterRegistrationComponent from "@/components/users/auth/PunterRegistrationComponent";
import PunterLoginComponent from "@/components/users/auth/PunterLoginComponent";
import localStorageMixin from "@/components/mixins/localStorageMixin";
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";
import ButtonWithLoadingComponent from "@/components/global/ButtonWithLoadingComponent";
import IconComponent from "@/components/global/IconComponent.vue";
import {checkmarkDouble} from "@/core/constants/icons";
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";

const data = () => ({
    activeTab: 'guest',
    user: null,
    tipAmount: 0,
    guestLoading: false,
})

function initModal(user, tipAmount) {
    this.user = user;
    this.tipAmount = tipAmount;
    this.activeTab = 'guest';
    this.guestLoading = false;
    $('#tipAuth').modal('show');
}

function changeTab(tab) {
    this.activeTab = tab;
}

async function buyAsGuest() {
    this.guestLoading = true;

    const [err, response] = await to(
        api.tips.guest.createCheckoutUrl(this.user.id, this.tipAmount),
    );

    const url = _.get(response, 'data.results.redirectUrl');

    if (err || !url) {
        this.guestLoading = false;
        return toastr.error(this.translate.home.errorCommon);
    }

    window.location.href = url;
}

function onRegistrationSuccess() {
    this.storeTipMeta();
    $('#tipAuth').modal('hide');
    window.location.href = regionRelativeUrl('/client/onboarding/');
}

function onLoginSuccess() {
    this.storeTipMeta();
    window.location.reload();
}

function storeTipMeta() {
    const metaObject = {
        redirectedFrom: 'tipProfileModal',
        tipProfileModalRedirector: {
            tipUsername: this.user.username,
            tipAmount: this.tipAmount,
            tipRedirectProfilePath: window.location.href,
        }
    };

    const expiration = moment().add(30, 'minutes').toISOString();
    this.setLocalStorageObject('loginMeta', metaObject, expiration);
}

export default {
    data,
    computed: {
        ...mapState(['translate']),
        isRegisterActive() {
            return this.activeTab === 'register';
        },
        isLoginActive() {
            return this.activeTab === 'login';
        },
        isGuestActive() {
            return this.activeTab === 'guest';
        },
        confirmText() {
            if (!this.user) return '';
            return this.translate.account.tips.confirmTipPurchase
                .replace(':username', this.user.username)
                .replace(':amount', this.tipAmount);
        },
    },
    methods: {
        checkmarkDouble,
        initModal,
        changeTab,
        buyAsGuest,
        onRegistrationSuccess,
        onLoginSuccess,
        storeTipMeta,
    },
    components: {
        IconComponent,
        ButtonWithLoadingComponent,
        PunterLoginComponent,
        PunterRegistrationComponent,
    },
    mixins: [userMixin, localStorageMixin, regionsUrlMixin],
    beforeDestroy() {
        window.clearModalFade();
    },
};
</script>
